import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { useClientId } from "../../../../components/ui/common";
import { useYamsContext } from "../../hooks";
import { Placemark } from "../../react-yandex-maps";
import { usePortalRootInstance } from "./hooks";

/**
 * Добавляет невидимый гео-объект на карту с пустым div'ом
 * В который сразу после монтирования отрендеривает портал с children'ами
 * @param geometry
 * @param radius
 * @param children
 * @returns {JSX.Element}
 */
export var ReactLayout = function ReactLayout(_ref) {
  var children = _ref.children,
    geometry = _ref.geometry,
    radius = _ref.radius;
  var _useYamsContext = useYamsContext(),
    portalLayout = _useYamsContext.portalLayout;
  var id = useClientId('portal');
  var _usePortalRootInstanc = usePortalRootInstance(id),
    _usePortalRootInstanc2 = _slicedToArray(_usePortalRootInstanc, 2),
    portalRootNode = _usePortalRootInstanc2[0],
    instanceCallbackRef = _usePortalRootInstanc2[1];
  var size = radius ? "".concat(2 * radius, "px") : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Placemark, {
    geometry: geometry,
    instanceRef: instanceCallbackRef,
    modules: ['geoObject.addon.balloon'],
    options: {
      balloonLayout: portalLayout,
      balloonOffset: [-radius, -radius],
      balloonPanelMaxMapArea: 0,
      iconLayout: null
    },
    properties: {
      height: size,
      id: id,
      width: size
    },
    "data-t-id": "enhancers-ReactLayout"
  }), portalRootNode && /*#__PURE__*/createPortal(children, portalRootNode));
};
ReactLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  geometry: PropTypes.arrayOf(PropTypes.number),
  radius: PropTypes.number
} : {};